module.exports = __webpack_public_path__ + "static/media/LancamentosFinanceiros4.4f75f5d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancLancamentosFinanceiros/LancamentosFinanceiros4.png
// module id = 2153
// module chunks = 0